// Central Time formatter (America/Chicago) — used everywhere times are displayed.
// Label auto-switches between CST and CDT depending on Daylight Saving — so
// during DST (roughly mid-March → early November) the label says CDT, and
// during standard time it says CST. This matches the operator's local clock
// exactly and avoids the "why is the label wrong?" bug.
const TZ = 'America/Chicago';

const timeFmt = new Intl.DateTimeFormat('en-US', {
  timeZone: TZ, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
});
const dateFmt = new Intl.DateTimeFormat('en-US', {
  timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
});
const dtFmt = new Intl.DateTimeFormat('en-US', {
  timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
});
// Dedicated formatter just to pull the short timezone name (CST or CDT).
const tzNameFmt = new Intl.DateTimeFormat('en-US', {
  timeZone: TZ, timeZoneName: 'short',
});

// Returns "CST" or "CDT" based on the instant's actual DST status.
export function centralTzLabel(isoOrDate) {
  const d = isoOrDate
    ? (typeof isoOrDate === 'string' ? new Date(isoOrDate) : isoOrDate)
    : new Date();
  if (Number.isNaN(d.getTime())) return 'CT';
  const parts = tzNameFmt.formatToParts(d);
  const tz = parts.find((p) => p.type === 'timeZoneName')?.value;
  // Fallback to a sane default if the runtime ever returns something weird.
  return tz === 'CST' || tz === 'CDT' ? tz : 'CT';
}

export function cstTime(isoOrDate) {
  if (!isoOrDate) return '--:--:--';
  const d = typeof isoOrDate === 'string' ? new Date(isoOrDate) : isoOrDate;
  if (Number.isNaN(d.getTime())) return '--:--:--';
  return `${timeFmt.format(d)} ${centralTzLabel(d)}`;
}

export function cstDate(isoOrDate) {
  if (!isoOrDate) return '—';
  const d = typeof isoOrDate === 'string' ? new Date(isoOrDate) : isoOrDate;
  if (Number.isNaN(d.getTime())) return '—';
  return dateFmt.format(d);
}

export function cstDateTime(isoOrDate) {
  if (!isoOrDate) return '—';
  const d = typeof isoOrDate === 'string' ? new Date(isoOrDate) : isoOrDate;
  if (Number.isNaN(d.getTime())) return '—';
  return `${dtFmt.format(d)} ${centralTzLabel(d)}`;
}

export default { cstTime, cstDate, cstDateTime, centralTzLabel };
